<template>
    <div id="request" class="container page mb-5">
        <h2 class="mb-5">Nieuwe Opdracht</h2>
        <div class="alert alert-success" role="alert" v-if="isSuccess">
            <strong>Succesvol verstuurd!</strong> De opdracht is naar alle professionals gestuurd.
        </div>
        <form  @submit.prevent="submit" class="row">
            <div class="col-md-6">
                <h5>De Opdracht</h5>
                <div class="form-group">
                    <input :class="['form-control', ($v.assignment.title.$dirty) ? ($v.assignment.title.$error) ?'is-invalid' : 'is-valid' : '']" placeholder="Titel" v-model="assignment.title"  :disabled="disabled"/>
                    <div class="invalid-feedback">
                        Titel van de opdracht is verplicht.
                    </div>
                </div>
                <div class="form-group">
                    <v-select label="name" :filterable="false" :options="$store.getters.cities" @search="onSearchCity" v-model="assignment.city" :class="['form-control', ($v.assignment.city.$dirty) ? ($v.assignment.city.$error) ?'is-invalid' : 'is-valid' : '']" placeholder="Plaats" name="city" id="city">
                        <template slot="no-options">
                            Zoek een plaats...
                        </template>
                        <template slot="option" slot-scope="option" class="m-0 p-0">
                            <div class="d-center m-0 p-0" >
                                {{ option.name }}
                            </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                                {{ option.name }}
                            </div>
                        </template>
                    </v-select>
                    <div class="invalid-feedback">
                        Plaatsnaam is verplicht.
                    </div>
                </div>
                <div class="form-group">
                    <select :class="['form-control mb-3', ($v.assignment.skills.$dirty) ? ($v.assignment.skills.$error) ?'is-invalid' : 'is-valid' : '']" v-model="selectedAssignmentSkill" @change="addSkill" :disabled="disabled">
                        <option value="-1">Selecteer vaardigheden...</option>
                        <optgroup>
                            <option :value="s" v-for="s in skills" :key="s.skillId" >{{s.description}}</option>
                        </optgroup>
                    </select>
                    <div class="invalid-feedback">
                        U dient minimaal 1 vaardigheid op te geven.
                    </div>
                    <h5 v-for="p in assignment.skills" :key="p.skillId" @click="removeSkill(p)" class="badge-horizontal mr-2 inline">
                        <span class="badge badge-pill badge-secondary clickable">{{p.skill.description}}</span>
                    </h5>
                </div>
            </div>
            <div class="col-md-6">
                <h5>Opdrachtomschrijving</h5>
                <div class="form-group">
                    <textarea :class="['form-control', ($v.assignment.description.$dirty) ? ($v.assignment.description.$error) ?'is-invalid' : 'is-valid' : '']" rows="9" placeholder="Geef hier een omschrijving van de inhoud van de opdracht..."  v-model="assignment.description" :disabled="disabled"></textarea>
                    <div class="invalid-feedback">
                        Opdrachtomschrijving is verplicht.
                    </div>
                </div>
                <div class="custom-control custom-checkbox text-right mb-3">
                    <input :class="['custom-control-input', ($v.assignment.conditions.$dirty) ? ($v.assignment.conditions.$error) ?'is-invalid' : 'is-valid' : '']" type="checkbox" value="" id="conditions"  v-model="assignment.conditions"  :disabled="disabled"  @change="$v.assignment.conditions.$touch" >
                    <label class="custom-control-label" for="conditions">
                        U gaat akkoord met de <strong class="terms" @click="downloadTerms">voorwaarden</strong> voor deze werkopdracht.
                    </label>
                </div>
                <div class="form-group text-right">
                    <loader width="3rem" class="mr-3" v-if="isSending"></loader>
                    <button type="submit" class="btn btn-outline-azure-dark btn-lg" :disabled="disabled">Plaats Opdracht</button>
                </div>
            </div>
            <div class="col-md-12">
                <hr />
                <planning :api="false" :assignment="assignment" @update="updatePlanning" @remove="removeUser" @send="submit" :edit="true"></planning>
            </div>
            <div class="col-md-12">
                <hr />
                <h4>Offerte</h4>
                <div class="table-responsive">
                    <table class="table">
                        <thead class="thead-azure-dark">
                            <tr>
                                <th class="nowrap">Omschrijving</th>
                                <th class="max100 nowrap text-right">Prijs</th>
                                <th class="max100 nowrap text-right">Totaal</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="nowrap">Inhuur professionals</td>
                                <td class="max100 nowrap text-right" >€ {{salesPrice.toFixed(2)}}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td class="nowrap">{{this.assignment.dates.length}} x Projectmanagement</td>
                                <td class="max100 nowrap text-right" >€ {{this.projectmanagementCosts.toFixed(2)}}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td class="nowrap"><strong>Subtotaal</strong></td>
                                <td class="max100 nowrap text-right" colspan="2"><strong>€ {{this.subtotal.toFixed(2)}}</strong></td>
                            </tr>
                            <tr>
                                <td class="nowrap">BTW 21%</td>
                                <td class="max100 nowrap text-right" colspan="2">€ {{this.tax.toFixed(2)}}</td>
                            </tr>
                            <tr>
                                <td class="nowrap"><strong>Totaal</strong></td>
                                <td class="max100 nowrap text-right" colspan="2"><strong>€ {{this.total.toFixed(2)}}</strong></td>
                            </tr>
                        </tbody>
                        <tfoot v-if="showUpdatePriceBtn">
                            <tr>
                                <td colspan="5" class="text-md-right text-left">
                                    <loader width="3rem" class="mr-3" v-if="isSending"></loader>
                                    <button v-else type="button" class="btn btn-danger" @click="getPrice(assignment.dates)">
                                        Update Prijs!
                                    </button>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import { validationMixin } from 'vuelidate';
import { required, requiredIf, minLength, maxLength, integer, minValue } from 'vuelidate/lib/validators';
import Loader from '@/components/Loader';
import Planning from '@/components/Planning';
import MultiDatePicker from '@/components/MultiDatePicker';
import { assignment, assignmentDate, assignmentUser } from '@/models/models.js';
const arrayNotEmpty = (value) => {
    return value.length > 0;
};
const mustBeTrue = (value) => {
    if(value != null)
    {
        return value
    }
    return true;
};
const greaterThanToday = (value, vm) => new Date(value) > new Date();

export default {
    mixins: [validationMixin],
    props: 
    {
    },
    components: {
        Loader,
        Planning,
        MultiDatePicker,
        vSelect
    },
    data() {
        return {
            isLoading: false,
            isSending: false,
            isSuccess: false,
            showUpdatePriceBtn: false,
            salesPrice: 0,
            selectedAssignmentSkill: -1,
            assignment: new assignment({ skills: [], dates: [], professionalsQty: (this.professionals) ? this.professionals.length || 1 : 1, conditions: false }),
        }
    },
    validations: {
        assignment: {
            conditions: {
                required,
                mustBeTrue
            },
            title: {
                required,
                minLength: minLength(2),
                maxLength: maxLength(50),
            },
            description: {
                required,
                minLength: minLength(2),
                maxLength: maxLength(2000),
            },
            professionalsQty: {
                integer,
            },
            city: {
                required
            },
            dates: {
                arrayNotEmpty,
                $each: {
                    date: {
                        required,
                    }
                }
            },
            skills: {
                arrayNotEmpty
            }
        }
    },
    mounted() {
        this.$store.dispatch("GET_SKILLS");
        this.populateAssignment().then((res) => {
            this.getPrice(res);
        });
    },
    methods: {
        downloadTerms() {
            this.$http.get("api/Assignments/Terms/Client", { responseType: 'blob' }).then((res) => {
                let blob = new Blob([res.data], { type: res.headers.get('content-type') });
                let link = window.document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                
                let disposition = res.headers.map["content-disposition"][0];
                let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                let matches = filenameRegex.exec(disposition);

                if(matches != null && matches.length > 1)
                    link.download = matches[1];

                window.document.body.appendChild(link);

                link.click();

                window.document.body.removeChild(link);
            });
        },
        onSearchCity(search, loading) {
            this.$store.dispatch('GET_CITIES', { search, loading });
        }, 
        addSkill() {
            const assignmentSkill = { 
                id: 0,
                skillId: this.selectedAssignmentSkill.id,
                skill: this.selectedAssignmentSkill
            };
            if(!this.assignment.skills.some((c) => { return c.skillId == assignmentSkill.skillId }) && !this.isLoading)
            {
                this.assignment.skills.push(assignmentSkill);
            }
            this.selectedAssignmentSkill = -1;
        },
        removeSkill(skill) {
            if(this.assignment.skills.indexOf(skill) >= 0 && !this.isLoading)
                this.assignment.skills.splice(this.assignment.skills.indexOf(skill), 1);
        },
        populateAssignment() {
            return new Promise((resolve, reject) => {
                if(this.professionals)
                {
                    if(this.professionals.length > 0)
                    {
                        let dates = [];

                        this.professionals.forEach(p => {
                            p.availableDates.forEach(d => {
                                if(!dates.some((c) => { return c.date == d }))
                                {
                                    dates.push(new assignmentDate({
                                        id: - (dates.length + 1),
                                        date: d,
                                        assignmentUsers: []
                                    }));
                                }
                                
                                let date = dates.find((c) => { return c.date == d });
                                if(date)
                                {
                                    date.assignmentUsers.push(new assignmentUser({
                                        id: - (date.assignmentUsers.length + 1),
                                        applicationUserId: p.applicationUserId,
                                        applicationUser: {
                                            firstName: p.firstName
                                        },
                                        assignmentStatusId: 1,
                                        startTime: '09:00',
                                        hours: 8,
                                        lockedHours: false
                                    }));
                                }
                            });
                        });
                        this.assignment.dates = dates;
                        return resolve(dates);
                    } else {
                        this.$router.push({ name: 'ClientDashboard' });
                        return reject();
                    }
                }
                return reject();
            })
        },
        updatePlanning(p)
        {
            let date = this.assignment.dates.find((d) => { return d.date == p.date && d.assignmentUsers.some((u) => { return u.applicationUserId == p.applicationUserId }) });
            
            if(date != null)
            {
                let user = date.assignmentUsers.find((u) => { return u.applicationUserId == p.applicationUserId });

                if(user != null)
                {
                    user.startTime = p.startTime;
                    user.hours = p.hours;
                    this.showUpdatePriceBtn = true;
                }
            }

        },
        removeUser(user) {
            let dates = this.assignment.dates.filter((d) => { return d.date == user.date });
            dates.forEach(d => {
                let u = d.assignmentUsers.findIndex((u) => { return u.applicationUserId == user.applicationUserId && u.startTime == user.startTime });
                if(u >= 0)
                {
                    d.assignmentUsers.splice(u, 1);
                    if(d.assignmentUsers.length == 0)
                    {
                        this.assignment.dates.splice(this.assignment.dates.indexOf(d), 1);
                    }
                    this.getPrice(this.assignment.dates);
                }
            })
        },
        submit() {
            this.$v.assignment.$touch();
            if(!this.$v.$invalid && !this.disabled)
            {
                this.isSending = true;

                let a = JSON.parse(JSON.stringify(this.assignment));
                
                a.dates.forEach(d => {
                    d.actualHours = 0;
                    d.assignmentUsers.forEach(u => {
                        let array = u.startTime.split(':'),
                            date = new Date(d.date);
                        date.setHours(array[0]);
                        date.setMinutes(array[1]);
                        date.setSeconds(0);
                        date.setMilliseconds(0);
                        u.startTime = date;
                    });
                });

                this.$http.post('api/Assignments', a).then(() => {
                    this.isSuccess = true;
                    this.isSending = false;
                    this.$parent.professionals = [];
                }).catch(() => {
                    this.isSending = false;
                    alert("Oops, er is iets fout gegaan, probeer nogmaals.")
                });
            }
        },
        getPrice(dates) {
            this.isSending = true;
            this.$http.post('api/Pricing', dates).then((res) => {
                this.salesPrice = res.data;
                this.isSending = false;
                this.showUpdatePriceBtn = false;
            }).catch(() => {
                this.isSending = false;
            })
        }
    },
    computed: {
        skills() {
            let skills = [];
            this.professionals.forEach((p) => {
                p.skills.forEach((s) => {
                    if(skills.indexOf(s) <= 0)
                        skills.push(s);
                });
            });

            if(skills.length > 0)
                return skills;
            return this.$store.getters.skills;
        },
        filters() {
            return this.$parent.filters;
        },
        professionals() {
            return this.$parent.professionals;
        },
        disabled() {
            if(this.isLoading || this.isSuccess || this.isSending)
                return true;
            return false;
        },
        projectmanagementCosts() {
            return this.assignment.dates.length * 50;
        },
        subtotal() {
            if(this.salesPrice)
                return this.projectmanagementCosts + this.salesPrice;
            return 0;
        },
        tax() {
            return this.total - this.subtotal;
        },
        total() {
            return this.subtotal * 1.21;
        }
    },
    watch:
    {
        filters:
        {
            handler(to)
            {
                this.assignment.skills = to.skills;
            },
            deep: true
        }
    }
}
</script>

<style scoped>
.max100 {
    max-width: 200px;
}
.terms {
    text-decoration: underline;
    cursor: pointer;
}
</style>